import { createSelector } from "reselect";
import { Map } from "immutable";

import { getInitialState } from "../reducers";
import { DspsState as State, DspsNormalisedEntities, Dsp } from "../models";

export const getEntities = (state: State) =>
    state.dsps.entities ? state.dsps.entities : getInitialState().entities;

export const getDsps = createSelector(
    getEntities,
    (entities: DspsNormalisedEntities) => entities.dsps,
);

export const getDspsArray = createSelector(
    getDsps,
    (dsps: Map<number, Dsp>) => dsps.toArray(),
);
